import { render, staticRenderFns } from "./TransportsBox.vue?vue&type=template&id=6d1d13ee&scoped=true"
import script from "./TransportsBox.vue?vue&type=script&lang=js"
export * from "./TransportsBox.vue?vue&type=script&lang=js"
import style0 from "./TransportsBox.vue?vue&type=style&index=0&id=6d1d13ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d13ee",
  null
  
)

export default component.exports